import { useOpenNewContactSidePanel } from "components/SidePanel/contact/NewContactSidePanel";
import React from "react";
import { Button } from "semantic-ui-react";

interface Props {
  onContactCreated: (contactId: number) => void
}

const NewContact = (props: Props) => {
  const openNewContactSidePanel = useOpenNewContactSidePanel();

  return <>
    <Button
      type="button"
      primary
      fluid
      onClick={() => openNewContactSidePanel({ onCreated: (contact) => props.onContactCreated(contact.contactId) })}
      style={{ marginBottom: 2 }}
    >
      {RESX.Buttons.btnNew}
    </Button>
  </>
};

export default NewContact;